import { ellipsis } from "@/common/style/commonStyle";
import { MEDIA_QUERIES } from "@/hooks/responsive";
import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		minWidth: "10rem",
		maxWidth: "30rem",
		width: "25rem",
		padding: `${tokens.spacingVerticalL} 16px`,

		[`@media ${MEDIA_QUERIES.isMobileMediumToSmall}`]: {
			width: "22rem",
		},
	},
	title: {
		fontSize: tokens.fontSizeBase200,
		fontWeight: tokens.fontWeightSemibold,
		marginBottom: "8px",
	},
	transferTargetComboBox: {
		marginBottom: "16px",
	},
	transferTargetOption: {
		...ellipsis(),
	},
	transferTargetOptionRow: {
		paddingLeft: "16px",
		paddingRight: "16px",
	},
	transferTargetOptionName: {
		fontWeight: tokens.fontWeightSemibold,
	},
	transferTargetOptionDescription: {
		color: tokens.colorNeutralForeground3,
		fontSize: tokens.fontSizeBase200,
	},
	listbox: {
		// Eight or so targets rather than five, since the popup opens near the top of the app and has the
		// room. The viewport share is what keeps it inside a short window, where the fixed part alone
		// would push it off the bottom and send it above the input instead.
		maxHeight: "min(60vh, 520px)",
	},
	noResultText: {
		margin: "0.25rem auto",
	},
	spinner: {
		margin: tokens.spacingHorizontalM,
	},
});
